module.exports = __webpack_public_path__ + "static/media/Modlin_Group_Andrew_500.e6620299.jpg";